<template>
<div class="is-fullheight is-flex align-center justify-center">
  <div class="signin-form">
    <grid :gap="3">
      <div class="is-flex justify-center"><logo width="10rem" /></div>
      <h3 class="title is-5 has-text-weight-light has-text-centered leading-spaced">Sign into your Snitch Account.</h3>
    </grid>
    <form class="box">
      <div class="has-text-centered">
        <h3 class="is-size-3">Two Factor Authentication</h3>
        <p class="mb-4">
          Enter the 6 digit code from the two-factor app on your mobile device.<br>
          If you've lost your device, you may <a @click="switchToRecovery">try one of your recovery codes.</a>
        </p>
      </div>
      <div class="columns is-centered">
        <div class="column is-6">
          <text-input 
            ref="codeInput"
            autofocus 
            :error="$root.errors.code" 
            required 
            v-if="tryRecoveryCode == false" 
            v-model="challenge.code">
            Code
          </text-input>
          <text-input 
            autofocus 
            ref="recoveryInput"
            :error="$root.errors.recovery_code" 
            required 
            v-else 
            v-model="challenge.recovery_code">
            Recovery Code
          </text-input>
        </div>
      </div>
      <div class="columns">
        <div class="column has-text-centered">
          <submit-button class="is-rounded" :working="working" @submit="submitChallenge">Submit</submit-button>
        </div>
      </div>
    </form>
  </div>
</div>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  data: () => ({
    loading: true,
    working: false,
    tryRecoveryCode: false,
    challenge: {
      code: '',
      recovery_code: ''
    }
  }),

  beforeCreate() {
    this.$bus.$emit('set-title', 'Two Factor Challenge')
  },

  mounted() {
    this.$refs.codeInput.focus()
  },
  
  methods: {
    submitChallenge() {
      this.working = true
      this.$store.dispatch('auth/send2FaChallenge', this.challenge)
        .then(() => {
          this.$store.dispatch('auth/loadUser').then(() => {
            this.$store.dispatch('auth/loadAccount').then(() => {
              this.$router.push({
                name: 'dashboard'
              })
            })
          })
        })
        .catch(error => {
          this.$toast.error(error.response.data.message)
        })
        .finally(() => this.working = false)
    },
    switchToRecovery() {
      this.tryRecoveryCode = true
      setTimeout(() => {
        this.$refs.recoveryInput.focus()
      }, 100)
    }
  },

  computed: {
    ...mapGetters('auth', [
      'user'
    ])
  }

}
</script>